import React, { useEffect } from 'react';
// import { Link } from 'react-router-dom';
import { useSpring, animated } from 'react-spring';
import { useGlobalState, useGlobalStateUpdate } from '../Context/GlobalState';

import './Projects.scss';

const Projects = (props) => {
  const visited = useGlobalState();
  const toggleVisited = useGlobalStateUpdate();

  useEffect(() => {
    if (!visited) {
      toggleVisited();
    }
  }, [visited, toggleVisited]);

  const fadeIn = useSpring({ opacity: 1, from: { opacity: 0 } });

  const slideUp = useSpring({
    opacity: 1,
    transform: 'translateY(0)',
    from: { opacity: 0, transform: 'translateY(-50px)' },
  });

  return (
    <section id='projects-content'>
      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>College Partners</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview college-partner'>
          <div className='projectContent bootcampContent'>
            <ul className='projectSkills'>
              <li>NextJS</li>
              <li>TypeScript</li>
              <li>PostCSS</li>
              <li>Tailwind</li>
              <li>Sanity.io</li>
              <li>Self hosted Sanity Studio</li>
              <li>Draft Mode: React Streaming</li>
              <li>Vercel</li>
              <li>Git</li>
            </ul>
            <a
              className='viewProject'
              href='https://partners.ascentfunding.com/nerdwallet/'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>
      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>Loan Origination System</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview college-los'>
          <div className='projectContent collegeLosContent'>
            <ul className='projectSkills'>
              <li>React</li>
              <li>TypeScript</li>
              <li>PHP</li>
              <li>Laravel</li>
              <li>Bootstrap</li>
              <li>AWS</li>
              <li>Redux</li>
              <li>React Final Form</li>
              <li>Cypress</li>
              <li>Git</li>
            </ul>
            <a
              className='viewProject'
              href='https://college.ascentfunding.com/application/'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>
      <div className='projectContainer mobile'>
        <animated.div style={slideUp} className='windowHeader'>
          {/* <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div> */}
          <div className='windowTitle'>AscentConnect: Student Success</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview student-success'>
          <div className='projectContent bootcampContent'>
            <ul className='projectSkills'>
              <li>React Native webview</li>
              <li>NextJS</li>
              <li>TypeScript</li>
              <li>PostCSS</li>
              <li>Tailwind</li>
              <li>Radix UI</li>
              <li>Fuse.js</li>
              <li>SwiperJS</li>
              <li>WordPress CMS w/ webpack</li>
              <li>SQL</li>
              <li>GraphQL</li>
              <li>Vercel</li>
              <li>Hubspot</li>
            </ul>
            <a
              className='viewProject'
              href='https://www.ascentfunding.com/magic-link/success/'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>
      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>Bootcamp Finder</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview bootcamp-finder'>
          <div className='projectContent bootcampContent'>
            <ul className='projectSkills'>
              <li>React</li>
              <li>Google Maps API</li>
              <li>PHP</li>
              <li>SQL</li>
              <li>WordPress REST API</li>
              <li>Plugin Development</li>
              <li>SCSS</li>
              <li>Bootstrap</li>
              <li>GIT</li>
              <li>Hubspot</li>
            </ul>
            <a
              className='viewProject'
              href='https://www.ascentfunding.com/bootcamp-finder/'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>
      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>Loan Sales App</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview loan-sales'>
          <div className='projectContent loanSalesContent'>
            <ul className='projectSkills'>
              <li>React</li>
              <li>TypeScript</li>
              <li>React router</li>
              <li>Shadcn</li>
              <li>Radix UI</li>
              <li>Tailwind</li>
              <li>TanStack Query</li>
              <li>TanStack Table</li>
              <li>AWS</li>
              <li>Playwright</li>
              <li>Git</li>
            </ul>
            <span className='viewProject'>Internal Project</span>
          </div>
        </animated.div>
      </div>
      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>Bootcamp Partners</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview partner'>
          <div className='projectContent partnerContent'>
            <ul className='projectSkills'>
              <li>Webpack</li>
              <li>WordPress</li>
              <li>Theme Development</li>
              <li>ACF</li>
              <li>PHP</li>
              <li>SQL</li>
              <li>SCSS</li>
              <li>Bootstrap</li>
              <li>GIT</li>
            </ul>
            <a
              className='viewProject'
              href='https://partner.ascentfunding.com/codesmith/?program=SKCSSEIRFT20#payment_calc_preview_scroll'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>
      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>Ascent Funding</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview ascent'>
          <div className='projectContent ascentContent'>
            <ul className='projectSkills'>
              <li>WordPress</li>
              <li>React</li>
              <li>Webpack</li>
              <li>ACF</li>
              <li>PHP</li>
              <li>SQL</li>
              <li>SCSS</li>
              <li>Bootstrap</li>
              <li>GIT</li>
              <li>Playwright</li>
              <li>Hubspot</li>
              {/* <li>Kinsta</li> */}
              <li>SEO & Schema</li>
              <li>Google Optimize</li>
              {/* <li>Google Tag Manager</li> */}
            </ul>
            <a
              className='viewProject'
              href='https://ascentfunding.com'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>

      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>Pearson Digital Marketing</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview pdm'>
          <div className='projectContent pdmContent'>
            <ul className='projectSkills'>
              <li>React</li>
              <li>Gatsby</li>
              <li>Headless Wordpress</li>
              <li>GraphQL</li>
              <li>Chakra UI</li>
              <li>Framer Motion</li>
              <li>SCSS</li>
              <li>Javascript</li>
              <li>Netlify</li>
              <li>GIT</li>
            </ul>
            <a
              className='viewProject'
              href='https://pearsondigitalmarketing.com'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>

      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>Pacific Beach Homes</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview pbhomes'>
          <div className='projectContent pbhomesContent'>
            <ul className='projectSkills'>
              <li>HTML</li>
              <li>SCSS</li>
              <li>Javascript</li>
              <li>PHP</li>
              <li>Wordpress</li>
              <li>Advanced Custom Fields</li>
              <li>Webpack</li>
              <li>Content</li>
              <li>SEO</li>
              <li>GIT</li>
            </ul>
            <a
              className='viewProject'
              href='https://pacificbeachhomes.com'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>

      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>La Jolla Agent</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview ljagent'>
          <div className='projectContent ljagentContent'>
            <ul className='projectSkills'>
              <li>HTML</li>
              <li>CSS</li>
              <li>SEO</li>
              <li>Wordpress</li>
              <li>Blogging</li>
              <li>Mailchimp</li>
              <li>Content</li>
            </ul>
            <a
              className='viewProject'
              href='https://lajollaagent.com'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>

      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>San Diego Playgrounds</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview playgrounds'>
          <div className='projectContent playgroundsContent'>
            <ul className='projectSkills'>
              <li>React</li>
              <li>Remix</li>
              <li>Typescript</li>
              <li>Tailwind</li>
              <li>SQLite</li>
              <li>Prisma</li>
              <li>Cypress</li>
              <li>Vitest</li>
              <li>MSW</li>
              <li>GitHub</li>
              <li>Fly.io</li>
            </ul>
            <a
              className='viewProject'
              href='https://sandiegoplaygrounds-263d.fly.dev'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>

      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>R.H. Bishop Books</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview bishop'>
          <div className='projectContent bishopContent'>
            <ul className='projectSkills'>
              <li>HTML</li>
              <li>CSS</li>
              <li>Squarespace</li>
              <li>Design</li>
            </ul>
            <a
              className='viewProject'
              href='https://www.rhbishopbooks.com/'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>

      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>Sam's Portfolio</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview samport'>
          <div className='projectContent samportContent'>
            <ul className='projectSkills'>
              <li>HTML</li>
              <li>SCSS</li>
              <li>Javascript</li>
              <li>PHP</li>
              <li>Wordpress</li>
              <li>Advanced Custom Fields</li>
            </ul>
            <a
              className='viewProject'
              href='https://sampearson.digital'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>

      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>Travel Theme</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview travel'>
          <div className='projectContent travelContent'>
            <ul className='projectSkills'>
              <li>HTML</li>
              <li>SCSS</li>
              <li>Javascript</li>
              <li>PHP</li>
              <li>GIT</li>
              <li>Wordpress</li>
              <li>Advanced Custom Fields</li>
            </ul>
            <a
              className='viewProject'
              href='https://travel.ryanpearson.website'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>

      {/* <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>Chiggy Bank</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview chiggybank'>
          <div className='projectContent chiggyContent'>
            <ul className='projectSkills'>
              <li>Python</li>
              <li>Flask</li>
              <li>PostgreSQL</li>
              <li>SQLAlchemy</li>
              <li>CSS</li>
              <li>Javascript</li>
              <li>User Authentication</li>
              <li>Session</li>
            </ul>
            <a
              className='viewProject'
              href='https://chiggybank.herokuapp.com/'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div> */}

      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>Login/Signup db Auth</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview burger'>
          <div className='projectContent burgerContent'>
            <ul className='projectSkills'>
              <li>React</li>
              <li>Redux</li>
              <li>JSX</li>
              <li>CSS</li>
              <li>Javascript</li>
              <li>User Authentication</li>
              <li>Local Storage</li>
              <li>Jest</li>
              <li>Firebase</li>
            </ul>
            <a
              className='viewProject'
              href='https://react-my-burger-7ef03.web.app/'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>

      {/* <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>Ravenous</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview ravenous'>
          <div className='projectContent ravenousContent'>
            <ul className='projectSkills'>
              <li>React</li>
              <li>JSX</li>
              <li>CSS</li>
              <li>Javascript</li>
              <li>Yelp API</li>
              <li>JSON</li>
            </ul>
            <a
              className='viewProject'
              href='https://ravenoussearch.netlify.app/'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div> */}

      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>Jammming</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview jamming'>
          <div className='projectContent jammingContent'>
            <ul className='projectSkills'>
              <li>React</li>
              <li>JSX</li>
              <li>CSS</li>
              <li>Javascript</li>
              <li>Spotify API</li>
              <li>JSON</li>
            </ul>
            <a
              className='viewProject'
              href='https://jammmming.netlify.app/'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>

      {/* <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>AudioDB</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview audioDB'>
          <div className='projectContent burgerContent'>
            <ul className='projectSkills'>
              <li>JSX</li>
              <li>CSS</li>
              <li>Javascript</li>
              <li>React</li>
              <li>Material UI</li>
            </ul>
            <a
              className='viewProject'
              href='https://audiodb.netlify.app/'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Project
            </a>
          </div>
        </animated.div>
      </div>

      <div className='projectContainer'>
        <animated.div style={slideUp} className='windowHeader'>
          <div className='browser-button-close'></div>
          <div className='browser-button-minimize'></div>
          <div className='browser-button-expand'></div>
          <div className='windowTitle'>Mr Robot</div>
        </animated.div>
        <animated.div style={fadeIn} className='preview robot'>
          <div className='projectContent robotContent'>
            <ul className='projectSkills'>
              <li>HTML</li>
              <li>CSS</li>
              <li>Javascript</li>
            </ul>
            <Link to='/projects/robot' className='viewProject'>
              View Project
            </Link>
          </div>
        </animated.div>
      </div> */}

      {/* 
                <div className='projectContainer'>
          <animated.div style={slideUp} className='windowHeader'>
            <div className='browser-button-close'></div>
            <div className='browser-button-minimize'></div>
            <div className='browser-button-expand'></div>
            <div className='windowTitle'>Gates Vacation Homes</div>
          </animated.div>
          <animated.div style={fadeIn} className='preview gatesVacation'>
            <div className='projectContent gatesContent'>
              <ul className='projectSkills'>
                <li>HTML</li>
                <li>SCSS</li>
                <li>PHP</li>
                <li>Local</li>
                <li>Wordpress</li>
              </ul>
            </div>
          </animated.div>
        </div> */}
    </section>
  );
};

export default Projects;
